import {
  HaNExploreListHorizontal,
  HaNRoomListHorizontal,
  HaNWorkspacesListHorizontal,
  useTabByPathname,
} from '@organisms';
import {forwardRef} from 'react';
import {SwiperRefType} from '@molecules';
import {AreaWithSensorInfo, MeetingRoom} from '@lib/store';
import {ExploreState} from 'src/components/pages/HereAndNow/useExploreState';
import {useHereAndNow} from '@pages';

type HaNHorizontalListContentProps = {
  buildingId: string;
  onClick: (resource: MeetingRoom | AreaWithSensorInfo) => void;
  startDateTime: string;
  showCalendarConsentMessageNoOccupancy: boolean;
  endDateTime: string;
  onSlideChange: (room: MeetingRoom | AreaWithSensorInfo) => void;
  exploreState: ExploreState;
};

export const HaNHorizontalListContent = forwardRef<SwiperRefType, HaNHorizontalListContentProps>(
  (
    {
      buildingId,
      endDateTime,
      onClick,
      onSlideChange,
      showCalendarConsentMessageNoOccupancy,
      startDateTime,
      exploreState,
    },
    ref,
  ) => {
    const {tab} = useHereAndNow();

    switch (tab) {
      case 'explore':
        return (
          <HaNExploreListHorizontal
            exploreState={exploreState}
            ref={ref}
          />
        );
      case 'rooms':
        return (
          <HaNRoomListHorizontal
            onClick={onClick}
            buildingId={buildingId}
            startDateTime={startDateTime}
            endDateTime={endDateTime}
            onSlideChange={onSlideChange}
            showCalendarConsentMessageNoOccupancy={showCalendarConsentMessageNoOccupancy}
            ref={ref}
          />
        );
      case 'workspaces':
        return (
          <HaNWorkspacesListHorizontal
            onClick={onClick}
            onSlideChange={onSlideChange}
            ref={ref}
          />
        );
      default:
        return (
          <HaNRoomListHorizontal
            buildingId={exploreState.buildingId}
            onClick={onClick}
            startDateTime={startDateTime}
            showCalendarConsentMessageNoOccupancy={showCalendarConsentMessageNoOccupancy}
            endDateTime={endDateTime}
            onSlideChange={onSlideChange}
            ref={ref}
          />
        );
    }
  },
);
